import { Input, Popover } from 'antd';

import { GLOBAL_PHONE_LIMIT } from '@app/components/Phone/constants';
import { usePhone, usePhoneEffects } from '@app/components/Phone/hooks';
import type { PhoneType } from '@app/components/Phone/types';
import { CountryList, Country } from '@app/components/Phone/ui';

import '@app/components/Phone/styles/Phone.desktop.scss';

const PF = 'phone';

export const Phone: PhoneType = ({
  countries,
  name = 'Phone',
  wrapperClassName,
  wrapperStyle,
  required = false,
  disabled = false,
  onFinish,
  onValidate,
  size = 'middle',
  phoneInputDataTestId = 'phone-input',
  readOnly,
  onFocus,
  onBlur,
  onCountryListOpenChange,
}) => {
  const {
    containerRef,
    popoverVisible,
    popoverVisibleHandler,
    togglePopover,
    selectedCountry,
    popoverWidth,
    availableCountries,
    onSelectCountry,
    maskedPhone,
    validation,
    onChangeHandler,
    onPasteHandler,
    errorHandler,
    initValue,
    updatePopoverWidthHandler,
    onFinishHandler,
    onValidateHandler,
    onUpdatePhoneHandler,
  } = usePhone({
    countries,
    name,
    required,
    disabled,
    onFinish,
    onValidate,
    readOnly,
    onCountryListOpenChange,
  });

  usePhoneEffects({
    errorHandler,
    initValue,
    updatePopoverWidthHandler,
    onFinishHandler,
    onValidateHandler,
    onUpdatePhoneHandler,
  });

  return (
    <div
      className={`${PF}_wrapper ${wrapperClassName} `}
      style={wrapperStyle}
      ref={containerRef}
    >
      <Input
        data-testid={phoneInputDataTestId}
        id={name}
        size={size}
        value={maskedPhone}
        maxLength={GLOBAL_PHONE_LIMIT}
        onChange={({ target: { value } }) => {
          onChangeHandler(value);
        }}
        onPaste={onPasteHandler}
        onFocus={onFocus}
        onBlur={onBlur}
        status={validation.errorMessage ? 'error' : undefined}
        disabled={disabled || readOnly}
        prefix={
          <Popover
            content={
              <CountryList
                countries={availableCountries}
                isOpen={popoverVisible}
                onSelect={onSelectCountry}
              />
            }
            open={popoverVisible}
            onOpenChange={popoverVisibleHandler}
            styles={{
              root: {
                width:
                  popoverWidth || containerRef?.current?.offsetWidth || 300,
              },
            }}
            placement="bottom"
            showArrow={false}
            arrow={false}
            className="phone_popover"
            openClassName="phone_popover_open"
            rootClassName="phone_popover_root"
            classNames={{ root: 'phone_popover_overlay' }}
            getPopupContainer={() => containerRef.current || document.body}
          >
            <Country
              onClick={togglePopover}
              countryAlpha2={selectedCountry?.Alpha2}
            />
          </Popover>
        }
        rootClassName={`${PF}_input_root`}
        classNames={{
          prefix: `${PF}_input_prefix`,
          input: `${PF}_input_input`,
        }}
      />
    </div>
  );
};
